import React, { useContext, useState } from "react";
import { AuthContext } from "../AuthContext";
import { submitFeedback } from "../api";
import { useAlert } from "../AlertContext";

function Feedback() {
  const { token } = useContext(AuthContext);
  const { showAlert } = useAlert();
  const [type, setType] = useState("BUG");
  const [message, setMessage] = useState("");
  const [github, setGithub] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitFeedback(token, { type, message, github });
      showAlert("Danke für dein Feedback!");
      setMessage("");
      setGithub(false);
      setType("BUG");
    } catch {
      showAlert("Senden fehlgeschlagen");
    }
  };

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h2 className="text-2xl mb-4">Fehler & Vorschläge</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="border p-2"
        >
          <option value="BUG">Fehler</option>
          <option value="SUGGESTION">Vorschlag</option>
        </select>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          rows="5"
          className="border p-2"
        />
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={github}
            onChange={(e) => setGithub(e.target.checked)}
          />
          Programmierauftrag erstellen (GitHub)
        </label>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded self-start"
        >
          Senden
        </button>
      </form>
    </div>
  );
}

export default Feedback;
